export default "__VITE_ASSET__f62fae0a__"